import { ButtonArrow } from "@thrivetribe/mvf.assets.icons.button-arrow";
import { Button } from "@thrivetribe/mvf.ui.atoms.button";
import {
  OnboardingPage,
  OnboardingPageBody,
  OnboardingPageContent,
  OnboardingPageCopy,
  OnboardingPageFooter,
} from "@thrivetribe/mvf.ui.organisms.onboarding-page";
import { useUser } from "components/user/UserContext";
import { differenceInYears } from "date-fns";
import { signupNavLink } from "Onboarding/utils";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import { ReactGa } from "ui/atoms/ReactGa";
import { ImagesUrl } from "configs/EnvironmentConfig";

const AlmostDone = () => {
  let navigate = useNavigate();
  let user = useUser();

  const onSubmit = () => {
    if (user.isLegacy && user.user?.personalDetails?.dateOfBirth) {
      let age = differenceInYears(new Date(), new Date(user.user?.personalDetails?.dateOfBirth));

      if (age >= 18 && age < 99) {
        navigate("/portal-setup/ethnicity");
      } else {
        navigate("/portal-setup/age");
      }
    } else {
      navigate("/portal-setup/age");
    }
  };

  const onBackClick = () => {
    navigate(-1);
  };

  return (
    <div className="almost-done">
      <Helmet>
        <title>Set up - Almost done</title>
      </Helmet>
      <OnboardingPage
        user={user?.displayName}
        links={signupNavLink}
        image={`${ImagesUrl}/rich.webp`}
        onButtonClick={() => navigate("/portal-setup/age")}
        authorName="Richard Crick"
        authorRole="Head of MAN v FAT"
        heading="Almost done! Just gotta check a few details"
        quote="We can't wait for you to get using the dugout! It's packed full of recipes, articles and support that'll help you smash your weight loss goals."
        hideSubnav
        onBackClick={onBackClick}
      >
        <OnboardingPageContent hasStickyFooter centralizeContent>
          <OnboardingPageBody>
            <OnboardingPageCopy>
              <h1>Almost done! Just gotta check a few details</h1>
            </OnboardingPageCopy>
          </OnboardingPageBody>
          <OnboardingPageFooter>
            <Button onClick={onSubmit} variant="primary" color="primary">
              Continue
              <ButtonArrow />
            </Button>
          </OnboardingPageFooter>
        </OnboardingPageContent>
      </OnboardingPage>
      <ReactGa eventName="start_portal_setup" eventParams={{ user_id: user.userId, event_category: "account setup" }} />
    </div>
  );
};

export default AlmostDone;
